/* eslint-disable*/

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import PropTypes from 'prop-types';
import Mobile from './scoreItem';

export const Tooltip = ({ children, type, height, width, item, viva }) => (
  <div className="mobile-tooltip">
    {viva !== 2 && (
      <img
        src={`/assets/img/cardIcons/${type}.svg`}
        height={height}
        width={width}
        className="tooltip-image"
        alt=""
      />
    )}
    {children.props?.children}
    <br />
    <a
      href={`/objektdetails/${item.id}`}
      className={`${viva !== 2 ? 'expose-link' : 'viva-link'} `}
    >
      Zum Exposé
    </a>
  </div>
);

Tooltip.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  viva: PropTypes.number.isRequired,
};

const accordian = ({
  type,
  handleChange,
  item,
  viva,
  newScore,
  expand,
  selectedLayer,
}) => (
  <div>
    <Accordion
      expanded={expand?.id === item.id && expand?.type === type}
      onClick={(e) => handleChange(item, type, e)}
    >
      <AccordionSummary>
        <Mobile
          type={type}
          item={item}
          height={20}
          width={13}
          viva={viva}
          newScore={newScore}
          selectedLayer={selectedLayer}
        />
      </AccordionSummary>
      <AccordionDetails id={`${viva === 2 ? 'viva-acc' : ''}`}>
        <Tooltip item={item} width={13} height={20} type={type} viva={viva}>
          {((type === 'kultur' ||
            type === 'Nahversorgung' ||
            type === 'opnv') &&
            newScore <= 0.04) ||
          (type === 'wohnlage' && newScore === 0) ? (
            <div key={type}>
              Für diese Immobilie konnte der Score leider nicht berechnet
              werden.
            </div>
          ) : (
            <>
              {type === 'wohnlage' && (
                <div key={type}>
                  Als Community entwickeln wir für die Bundesrepublik
                  Deutschland flächendeckend eine Systematik zur Bewertung von
                  Wohnlagen inklusive der flächendeckenden vor Ort Bewertung von
                  Wohnquartieren.
                  <br />
                  <br />
                  Initiator und Moderator ist Zukunfts-, Markt- und
                  Preisforschung | IIB Institut
                </div>
              )}
              {type === 'opnv' && (
                <div key={type}>
                  Wie gut ist die Anbindung an den öffentlichen Nahverkehr? Der
                  Score berücksichtigt z. B. die Nähe zur nächsten Bus- und
                  Bahnhaltestelle und wie viele Personen sie wie schnell damit
                  erreichen können.
                  <br />
                  <br />
                  Initiator und Moderator ist Zukunfts-, Markt- und
                  Preisforschung | IIB Institut
                </div>
              )}
              {type === 'Nahversorgung' && (
                <div key={type}>
                  Habe ich vor Ort, was ich brauche? Dieser Score bildet ab, wie
                  verfügbar Versorgungsangebote des alltäglichen Bedarfs sind.
                  Enthalten sind z. B. Supermärkte, Drogerien, Kindergärten,
                  Schulen, Krankenhäuser und Apotheken
                  <br />
                  <br />
                  Initiator und Moderator ist Zukunfts-, Markt- und
                  Preisforschung | IIB Institut
                </div>
              )}
              {type === 'kultur' && (
                <div key={type}>
                  Ist hier etwas los? Der Score bildet kulturelle
                  Dienstleistungen zur Freizeit- und Abendgestaltung ab, an
                  denen sich Menschen versammeln können. Enthalten sind z. B.
                  Restaurants, Cafes, Biergärten, Museen, Theater, Kinos,
                  Nachtclubs und Bars.
                  <br />
                  <br />
                  Initiator und Moderator ist Zukunfts-, Markt- und
                  Preisforschung | IIB Institut
                </div>
              )}
            </>
          )}
        </Tooltip>
      </AccordionDetails>
    </Accordion>
  </div>
);

export default accordian;
